





























import Vue from 'vue';

import Address from '@/components/Address.vue';
import Field from '@/components/Bulma/Field.vue';
import TInput from '@/components/Bulma/TInput.vue';
import HorizontalField from '@/components/Bulma/HorizontalField.vue';

import ContactInfo from '@/types/ContactInfo';
import Util from '@/util/Util';
import ValidateUtil from '@/util/ValidateUtil';
import { AxiosError, AxiosResponse } from 'axios';
import OrderAPI from '@/services/OrderAPI';

import utilMixin from '@/mixin/Util';

export default Vue.extend({
    name: 'ContactSelector',

    components: {
        Address,
        Field,
        TInput,
        HorizontalField
    },

    mixins: [utilMixin],

    props: {
        currentContactInfo: Object as () => ContactInfo,
        orderId: String,
        readonly: Boolean,
        isBoxed: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            contactInfo: new ContactInfo(),
            error: {
                save: ''
                },
            isLoading: false
        };
    },

    created() {
		if (this.currentContactInfo) {
            this.contactInfo = JSON.parse(JSON.stringify(this.currentContactInfo));
        }
    },

    methods: {
        input(): void {
            this.$emit('input', !this.isChangesMade());
        },

        setContactInfo(): void {
            const errors = ValidateUtil.validateContactInfo(this.contactInfo);

            this.error.save = errors.length !== 0 ? (this as any).$text('mustSupply') + ' ' + errors.join(', ') : '';

            if (!Util.isEmpty(this.error.save)) {
                return;
            }

            const handleResponse = (response: AxiosResponse) => {
                    if (response.data) {
                        this.$emit('input', true);
                        this.$store.commit('setOrder', response.data);
                    }
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        this.error.save = error.response.data.message;
                    }
                };

            this.isLoading = true;
            OrderAPI
                .setContactInfo(this.orderId, this.contactInfo)
                .then(handleResponse)
                .catch(handleError)
                .finally(() => this.isLoading = false);
        },

        isChangesMade(): boolean {
            return this.currentContactInfo === undefined && this.contactInfo !== undefined ||
                !this.isEqual();
        },

        isEqual(): boolean {
            return this.currentContactInfo === undefined && this.contactInfo === undefined ||
                this.currentContactInfo.email === this.contactInfo.email &&
                this.currentContactInfo.mobileNumber === this.contactInfo.mobileNumber &&
                this.currentContactInfo.address.recipientName === this.contactInfo.address.recipientName &&
                this.currentContactInfo.address.careOfName === this.contactInfo.address.careOfName &&
                this.currentContactInfo.address.streetAddress === this.contactInfo.address.streetAddress &&
                this.currentContactInfo.address.postalCode === this.contactInfo.address.postalCode &&
                this.currentContactInfo.address.city === this.contactInfo.address.city &&
                this.currentContactInfo.address.countryCode === this.contactInfo.address.countryCode;
        }
    }
});
